var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youku-play-page"},[_vm._m(0),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"video-info"},[_c('h1',[_vm._v(_vm._s(_vm.videoInfo.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.videoInfo.brief))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('div',{staticClass:"player",attrs:{"id":"youkuplayer"}})])
}]

export { render, staticRenderFns }